export class Mensaje {
  enviado_por?: string;
  fecha?: string;
  hora?: string;
  mensaje?: string;
  tipo?: number;
}
